import { render, staticRenderFns } from "./upgradeStrategy.vue?vue&type=template&id=28a80d24&scoped=true"
import script from "./upgradeStrategy.vue?vue&type=script&lang=js"
export * from "./upgradeStrategy.vue?vue&type=script&lang=js"
import style0 from "./upgradeStrategy.vue?vue&type=style&index=0&id=28a80d24&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a80d24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a80d24')) {
      api.createRecord('28a80d24', component.options)
    } else {
      api.reload('28a80d24', component.options)
    }
    module.hot.accept("./upgradeStrategy.vue?vue&type=template&id=28a80d24&scoped=true", function () {
      api.rerender('28a80d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/upgradeStrategy.vue"
export default component.exports